import React from 'react';
import './About.css';

const About: React.FC = () => {
    return (
        <div className="about-container">
            <h1>About Us</h1>
            <section className="about-section">
                <div className="about-header">
                    <svg className="about-icon" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                    </svg>
                    <h2>Our Vision</h2>
                </div>
                <p>
                    To empower every Zambian to reach their full potential and create thriving, sustainable communities.
                </p>
            </section>
            <section className="about-section">
                    <div className="about-header">
                        <svg className="about-icon" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12 2a10 10 0 100 20 10 10 0 000-20zm1 15h-2v-2h2v2zm1.07-7.75l-.9.92C11.45 11.9 11 13 11 14h2v-.5c0-.55.22-1.05.59-1.41l1.2-1.2c.37-.37.59-.87.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H9c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .88-.36 1.68-.93 2.25z"/>
                        </svg>
                        <h2>Our Mission</h2>
                    </div>
                    <p>
                        To improve lives by advocating for inclusive socioeconomic policies, promoting economic empowerment, environmental sustainability, and community-driven development for a dignified and sustainable future in Zambia.
                    </p>
            </section>
            <section className="about-section">
                    <div className="about-header">
                        <svg className="about-icon" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
                        </svg>
                        <h2>Core Values</h2>
                    </div>
                    <ul className="core-values-list">
                        <li>Integrity</li>
                        <li>Inclusivity</li>
                        <li>Transparency</li>
                        <li>Collaboration</li>
                        <li>Innovation</li>
                        <li>Empowerment</li>
                    </ul>
            </section>
            <section className="about-section">
                <div className="about-header">
                    <svg className="about-icon" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                    </svg>
                    <h2>General Objective</h2>
                </div>
                <p>
                    To improve the quality of life for Zambians by promoting inclusive and sustainable socioeconomic policies.
                </p>
            </section>
            <section className="about-section">
                <div className="about-header">
                    <svg className="about-icon" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z"/>
                    </svg>
                    <h2>Specific Objectives</h2>
                </div>
                <ol className="objectives-list">
                    <li>
                        <strong>Governance</strong><br/>
                        Promote transparency, accountability, and citizen participation in governance processes to strengthen democratic institutions and ensure effective public service delivery.
                    </li>
                    <li>
                        <strong>Policy Advocacy and Reform</strong><br/>
                        Advocate for and support the development and implementation of progressive socioeconomic policies that address poverty, inequality, and social justice.
                    </li>
                    <li>
                        <strong>Environmental Sustainability</strong><br/>
                        Promote policies and practices that support environmental conservation and sustainable development to ensure a healthy future for all.
                    </li>
                    <li>
                        <strong>Research and Data Collection</strong><br/>
                        Conduct research and collect data to inform policy recommendations and track the impact of implemented policies and programs.
                    </li>
                    <li>
                        <strong>Partnership Building</strong><br/>
                        Foster partnerships with government, private sector, and other non-profits to create synergies and maximize the impact of socioeconomic initiatives.
                    </li>
                    <li>
                        <strong>Cultural Paradigm Shift</strong><br/>
                        Catalyze measurable shifts in Zambia's cultural paradigms—targeting dimensions such as power distance, uncertainty avoidance, short-termism, and other globally recognized cultural metrics.
                    </li>
                    <li>
                        <strong>Doctrine of Remembrance</strong><br/>
                        Embed remembrance of Zambia's cultural heritage and global historical ruptures into civic education, public rituals, and national consciousness.
                    </li>
                </ol>
            </section>
            <section className="about-section">
                <h2>Organisational Documents</h2>
                <ul className="documents-list">
                    <li>Strategic Plan</li>
                    <li>Articles of Association</li>
                    <li>Code of Ethics</li>
                </ul>
            </section>
        </div>
    );
};

export default About;